"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.opRefundSlipSchema = exports.opRefundRequestDetailSchema = exports.listOpRefundRequestsResponseSchema = exports.opRefundRequestSchema = void 0;
const zod_1 = require("zod");
const financial_refund_request_request_1 = require("../request/financial-refund-request.request");
/**
 * ONE REFUND REQUEST, as either role reads it — the requester's own list, the
 * approver's queue, and the shared register are the SAME shape (desk,
 * 2026-09-12: "list and register both required for user and main counter
 * roles"). Every money figure is a field the SERVER computed; nothing here is
 * netted client-side.
 */
exports.opRefundRequestSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    requestNumber: zod_1.z.string(),
    status: financial_refund_request_request_1.opRefundRequestStatusEnum,
    finReceiptId: zod_1.z.string().uuid(),
    receiptNumber: zod_1.z.string(),
    finInvoiceId: zod_1.z.string().uuid().nullable(),
    invoiceNumber: zod_1.z.string().nullable(),
    finInvoiceLineId: zod_1.z.string().uuid().nullable(),
    lineDescription: zod_1.z.string().nullable(),
    patientId: zod_1.z.string().uuid().nullable(),
    patientName: zod_1.z.string().nullable(),
    requestedAmountPaise: zod_1.z.number().int(),
    reason: zod_1.z.string().nullable(),
    requestedBy: zod_1.z.string().uuid().nullable(),
    requestedByName: zod_1.z.string().nullable(),
    requestedAt: zod_1.z.string(),
    decidedBy: zod_1.z.string().uuid().nullable(),
    decidedByName: zod_1.z.string().nullable(),
    decidedAt: zod_1.z.string().nullable(),
    rejectionReason: zod_1.z.string().nullable(),
    processedPaymentId: zod_1.z.string().uuid().nullable(),
    processedAt: zod_1.z.string().nullable(),
    failureReason: zod_1.z.string().nullable(),
    lockVersion: zod_1.z.number().int(),
});
exports.listOpRefundRequestsResponseSchema = zod_1.z.object({
    requests: zod_1.z.array(exports.opRefundRequestSchema),
});
/**
 * THE APPROVER'S OWN DETAIL READ — everything needed for a safe financial
 * decision, freshly computed, never the figure the requester's screen sent
 * (desk: "The approver must NOT rely on stale frontend values").
 */
exports.opRefundRequestDetailSchema = exports.opRefundRequestSchema.extend({
    originalBilledAmountPaise: zod_1.z.number().int(),
    originalPaymentAmountPaise: zod_1.z.number().int(),
    alreadyRefundedAmountPaise: zod_1.z.number().int(),
    currentRefundableAmountPaise: zod_1.z.number().int(),
    remainingHeadroomAfterThisRequestPaise: zod_1.z.number().int(),
});
/**
 * THE PRINT SLIP — server-built, one shot. Never recomputed by the browser;
 * see `RefundSlipDocument.tsx`'s own header comment.
 */
exports.opRefundSlipSchema = zod_1.z.object({
    request: exports.opRefundRequestSchema,
    hospitalName: zod_1.z.string(),
    patientUhid: zod_1.z.string().nullable(),
    paymentModeName: zod_1.z.string().nullable(),
    refundPaymentNumber: zod_1.z.string().nullable(),
    printCount: zod_1.z.number().int(),
});
//# sourceMappingURL=financial-refund-request.response.js.map